<div id="loding" [ngClass]="{ 'loding-hide': lodingImage }">
  <img src="assets/img/loding.gif" />
</div>
<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12 headboxes">
        <div class="card p-0">
          <div class="card-block p-0">
            <div
              class="heading-box"
              style="background-image: url(assets/img/camp.png)"
            >
              <div class="row align-items-center">
                <div class="col-md-6">
                  <div class="pagename">
                    <h3 class="card-title">Community Resources</h3>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="total-count">
                    <h5 class="m-0">Total</h5>
                    <h2>
                      {{
                        communityResourcesTotal ? communityResourcesTotal : 0
                      }}
                    </h2>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="addbtn">
                    <button
                      id="add_btn"
                      type="button"
                      class="btn btn-primary addbtn"
                      (click)="open(content)"
                      style="float: right"
                    >
                      Add Community Resources
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-block">
            <div id="table" class="table-responsive">
              <table
                datatable
                id="partneroffertable"
                [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger"
                class="table"
                width="100%"
              >
                <thead>
                  <tr>
                    <th style="width: 5%">#Sl</th>
                    <th>Title</th>
                    <th>Comments</th>
                    <th>Category</th>
                    <th>Mentions</th>
                    <th>Created Date</th>
                    <th style="width: 5%">Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody *ngIf="communityResourcesList?.length != 0">
                  <tr
                    *ngFor="let item of communityResourcesList; let i = index"
                    [attr.data-index]="i"
                  >
                    <td>{{ getRowNumber(i) }}</td>
                    <td>{{ item.title }}</td>
                    <td>{{ item.Comments }}</td>
                    <td>{{ item.category_name }}</td>
                    <td>
                      {{ item.getMentions.length }}&nbsp;
                      <button
                        *ngIf="item?.getMentions.length > 0"
                        type="button"
                        class="btn text-dark btn-sm rounded bg-light"
                        (click)="onViewMentionUsers(item, mentionuser)"
                      >
                        <i class="fa fa-solid fa fa-list"></i>
                      </button>
                    </td>
                    <td>{{ item.created_date }}</td>
                    <td>
                      <span
                        *ngIf="item.inactive == 'Y'"
                        class="badge badge-success badge-pill"
                        >Active</span
                      >
                      <span
                        *ngIf="item.inactive == 'N'"
                        class="badge badge-danger badge-pill"
                        >Inactive</span
                      >
                    </td>

                    <td class="action">
                      <label class="switch">
                        <input
                          type="checkbox"
                          (change)="delete(item)"
                          [checked]="item.inactive === 'Y'"
                        />
                        <span class="slider round"></span>
                      </label>

                      <button
                        type="button"
                        class="btn text-dark btn-sm rounded bg-light"
                        (click)="
                          edit(this.communityResourcesList[i].id, content, item)
                        "
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>

                <tbody *ngIf="communityResourcesList?.length == 0">
                  <tr>
                    <td colspan="8" class="no-data-available text-center">
                      No data available!
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template
      #content
      let-c="close"
      let-d="dismiss"
      id="customer-add"
      class=""
    >
      <div class="modal-info" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ modalTitle }}</h4>
            <button
              type="button"
              class="close"
              aria-label="Close"
              (click)="d('Cross click')"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <alert>
              <div class="alert alert-danger"><a class="close">×</a></div>
            </alert>

            <form
              method="post"
              enctype="multipart/form-data"
              class="form-horizontal"
              #f="ngForm"
            >
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="title" class="col-form-label"
                    >Title <span>*</span></label
                  >
                  <div class=" ">
                    <input
                      class="form-control"
                      type="text"
                      id="title"
                      name="title"
                      required
                      [(ngModel)]="community_resources.title"
                    />
                    <span
                      *ngIf="
                        isSubmitted &&
                        isFieldsInvalid(community_resources.title)
                      "
                      class="alert-block text-sm"
                      >This field is required</span
                    >
                  </div>
                </div>

                <div class="form-group col-6">
                  <label for="PostCategoryId" class="col-form-label"
                    >Category<span>*</span></label
                  >
                  <div class="">
                    <select
                      class="form-control"
                      required
                      id="PostCategoryId"
                      name="PostCategoryId"
                      [(ngModel)]="community_resources.PostCategoryId"
                    >
                      <option value="" selected disabled>Select</option>
                      <option
                        *ngFor="let item of categoryArr"
                        value="{{ item.id }}"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <span
                      *ngIf="
                        isSubmitted &&
                        (community_resources.PostCategoryId == undefined ||
                          community_resources.PostCategoryId == '')
                      "
                      class="alert-block"
                      >This field is required</span
                    >
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <label for="validationCustom11" class="form-label"
                    >Mentions</label
                  >
                  <ng-select
                    [items]="mentionUsers"
                    [(ngModel)]="mentionUsersSelected"
                    name="mention_users"
                    [multiple]="true"
                    bindLabel="name"
                    bindValue="id"
                    [searchable]="true"
                    [virtualScroll]="true"
                    (search)="filterMentions($event)"
                  >
                  </ng-select>
                </div>

                <div class="form-group col-md-6">
                  <label for="comments" class="col-form-label"
                    >Comments <span class="text-danger">*</span></label
                  >
                  <div class="">
                    <textarea
                      class="form-control"
                      required
                      type="text"
                      id="comments"
                      name="comments"
                      [(ngModel)]="community_resources.Comments"
                    ></textarea>

                    <span
                      *ngIf="
                        isSubmitted &&
                        isFieldsInvalid(community_resources.Comments)
                      "
                      class="alert-block text-sm"
                      >This field is required</span
                    >
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="resourceType" class="col-form-label"
                      >Resource Type <span>*</span></label
                    >
                    <div class="mt-2">
                      <input
                        type="radio"
                        id="fileUpload"
                        name="resourceType"
                        value="file"
                        required
                        checked
                        [(ngModel)]="community_resources.resource_type"
                      />&nbsp;
                      <label for="fileUpload">File Upload</label
                      >&nbsp;&nbsp;&nbsp;&nbsp;

                      <div
                        *ngIf="
                          isSubmitted &&
                          (community_resources.resource_type == undefined ||
                            community_resources.resource_type == '')
                        "
                        class="alert-block"
                      >
                        This field is required
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-md-6"
                  *ngIf="community_resources.resource_type == 'file'"
                >
                  <div class="form-group">
                    <label for="comments" class="col-form-label"
                      >Resource File Upload
                      <span class="text-danger">*</span></label
                    >

                    <div>
                      <input
                        type="file"
                        class="custom-file-input1"
                        #fileInput
                        id="file-ip-02"
                        accept="{{ pdfTypeTitle }}"
                        (change)="pdfChangeTitle($event)"
                        [attr.multiple]="allowMultiple"
                      />
                    </div>

                    <div class="d-flex mt-3 flex-wrap">
                      <div class="download-pdf">
                        <div class="download-list">
                          <ul>
                            <li *ngFor="let item of pdfSrcTitle" class="mb-2">
                              <div class="d-flex w-100 align-items-center">
                                <span class="fs-3 me-2"
                                  ><i
                                    class="fas fa-file-pdf"
                                    aria-hidden="true"
                                  ></i
                                ></span>
                                <span class="w-75">{{ item.name }}</span
                                >&nbsp;&nbsp;

                                <button
                                  type="button"
                                  (click)="removePdf(item, fileInput)"
                                  class="btn text-dark btn-sm border-0 rounded bg-light"
                                >
                                  <i class="fa fa-times"></i>
                                </button>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">
                      <div class="download-pdf">
                        <div class="download-list">
                          <ul>
                            <li
                              *ngFor="let item of editpdfSrcTitle"
                              class="mb-2"
                            >
                              <div class="d-flex w-100 align-items-center">
                                <span class="fs-3 me-2"
                                  ><i
                                    class="fas fa-file-pdf"
                                    aria-hidden="true"
                                  ></i
                                ></span>
                                <span class="w-75">{{ item.name }}</span
                                >&nbsp;&nbsp;
                                <button
                                  class="btn btn-outline-dark border-0 p-2"
                                  (click)="removeEditPdf(item)"
                                >
                                  <i class="fa fa-times" aria-hidden="true"></i>
                                </button>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer mt-2">
            <button
              type="button"
              class="btn btn-secondary d-none"
              aria-label="Close"
              (click)="d('Cross click')"
            >
              Close
            </button>
            <button
              type="submit"
              class="btn btn-primary savebtn"
              (click)="save(this.community_resources, f)"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<!--Mention User modal-->
<ng-template
  #mentionuser
  let-c="close"
  let-d="dismiss"
  id="view-report"
  class=""
>
  <div class="modal-info" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{ modalTitle }}</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="d('Cross click')"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <alert>
          <div class="alert alert-danger"><a class="close">×</a></div>
        </alert>

        <div id="table" class="table-responsive">
          <table
            datatable
            id="view-report"
            [dtOptions]="dtOptions"
            [dtTrigger]="dtTrigger"
            class="table"
            width="100%"
          >
            <thead class="bg-light">
              <tr>
                <th>#Sl</th>
                <th>Image</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of mentionUserArr; let i = index"
                [attr.data-index]="i"
              >
                <td>{{ i + 1 }}</td>
                <td>
                  <img
                    *ngIf="item.image"
                    style="border-radius: 30px"
                    height="60px"
                    width="60px"
                    [src]="item.image"
                  />

                  <img
                    *ngIf="!item.image"
                    style="border-radius: 30px"
                    src="assets/img/default-profile.png"
                    height="60px"
                    width="60px"
                  />
                </td>

                <td>
                  <a
                    *ngIf="item.type == '5'"
                    target="_blank"
                    [href]="
                      getbaseUrl + 'mentee-community-details?slug=' + item?.slug
                    "
                    ><span>{{ item.name }}</span></a
                  >

                  <a
                    *ngIf="item.type == '3'"
                    target="_blank"
                    [href]="
                      getbaseUrl + 'mentor-community-details?slug=' + item?.slug
                    "
                    ><span>{{ item.name }}</span></a
                  >

                  <a
                    *ngIf="item.type == '4'"
                    target="_blank"
                    [href]="
                      getbaseUrl + 'partner-community-detailsslug=' + item?.slug
                    "
                    ><span>{{ item.name }}</span></a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary d-none"
          aria-label="Close"
          (click)="d('Cross click')"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>
